import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import Title from "../component/title";
import CityPicker from "./component/city-picker";
import Empty from "@/component/empty";
import { cloneDeep, isEmpty, round } from "lodash";
import { styled } from "@mui/system";
import { LinearProgress, Tab, Tabs } from "@mui/material";
import Color from "@/tool/color";
import TabChange from "./component/tab-change";
import WelfareRank from "./component/welfare-rank";
import moWelfare, {
  changeAllYearMid,
  changeAllYearTab,
  changeKeyHoliday,
  changeKeyHolidayMid,
  changeKeyHolidayTab,
} from "./store/wealfare";
import { RankingLIcon, RankingRIcon } from "@/styled/icon";
import "./scss/hobby.scss";
import WelfareEchangeCity from "./component/welfare-echange-city";
import HolidayEchangeCity from "./component/holiday-echange-city";
import KeyWelfareRank from "./component/welfare-rank-key";
import HolidayChange from "./component/holiday-change";
import moIndex from "../store";

interface IProps {}
interface IState {}

const Hobby = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    allYearDefault,
    allYearRankLeft,
    allYearRankMid,
    allYearRankRight,
    keyHolidayData,
    keyHolidayNum,
    keyHolidayLeft,
    keyHolidayMid,
    activeDay,
    keyHolidayRight,
  } = moWelfare;
  const { isMock } = moIndex;
  const colorList = [Color.three, Color.blackColor(0.65), Color.copper];

  const getkeyHolidayRightThree = useMemo(() => {
    const list = cloneDeep(keyHolidayRight);
    return list.slice(0, 3);
  }, [keyHolidayRight]);

  const DProgress = styled(LinearProgress)({
    width: "100%",
    height: "6px",
    borderRadius: "4px",
    backgroundColor: Color.blackColor(0.04),
  });

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="hobby-page-warp">
      <section className="tops-title-warps" id="hobby">
        <Title title="福利洞察" subtitle="员工喜好" />
        <CityPicker />
      </section>
      <span className="update-time">
        统计周期：最近12个月，更新时间：2021-12
      </span>
      <span className="update-time">
        喜好说明：企业发放各种礼包、礼券、积分后，在弹性福利平台，员工优先兑换的商品或品牌。分别提供了重点节日的兑换情况。
      </span>
      <section className="hobby-exchange-warp">
        <section className="welfare-rank" id="welfare2">
          <section id="welfare22">
            <section className="welfare-rank-top">
              <span className="sub-title">全年福利兑换排行</span>
              <TabChange
                code={allYearDefault}
                onChange={(val: string) => {
                  changeAllYearTab(val);
                }}
              />
            </section>
            <section className="welfare-rank-top-detail">
              <p>数据说明：</p>
              <p>
                人数占比 = 各项福利兑换人数 /
                福利总兑换人数。因为一个员工可能兑换一项或多项福利，因此各项占比加总会超过100%
              </p>
              <p>数量占比 = 各项福利兑换金额 / 福利总兑换金额</p>
            </section>
            {!isEmpty(allYearRankLeft) ? (
              <section
                className="welfare-rank-content"
                style={{
                  backgroundImage: isMock
                    ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
                    : "",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                }}
              >
                <WelfareRank
                  onChange={(val: string) => {
                    changeAllYearMid(val);
                  }}
                />
                <section className="welfare-rank-mid">
                  {allYearRankMid?.map((item: any, i: any) => {
                    return (
                      <section
                        className="welfare-rank-mid-con"
                        key={`${i.toString()}`}
                      >
                        <p>
                          <span>{item.name}</span>
                          <span
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {round(item.percent * 100, 1)}%
                          </span>
                        </p>
                        <DProgress
                          variant="determinate"
                          value={item.percent * 100}
                        />
                      </section>
                    );
                  })}
                </section>
                <section className="welfare-rank-right">
                  <section className="welfare-rank-right-title">
                    <span className="sub-title">品牌</span>
                  </section>
                  {allYearRankRight?.map((item: any, i: any) => {
                    return (
                      <section
                        key={`${i.toString()}`}
                        className="welfare-rank-right-list"
                      >
                        {i < 3 && (
                          <p style={{ color: colorList[i] }}>
                            <RankingLIcon color={colorList[i]} />
                            {i + 1}
                            <RankingRIcon color={colorList[i]} />
                          </p>
                        )}
                        {i > 2 && <span>{i + 1}</span>}
                        <span className="content">{item.name}</span>
                      </section>
                    );
                  })}
                </section>
              </section>
            ) : (
              <Empty />
            )}
          </section>
          <section>
            <WelfareEchangeCity />
          </section>
        </section>
      </section>

      <section style={{ backgroundColor: Color.white }}>
        {/* 重点节日兑换排行 */}
        {!isEmpty(keyHolidayData) && (
          <section className="welfare-festival-rank">
            <section id="festivalrank">
              <section className="welfare-rank-top">
                <section>
                  <span className="sub-title">重点节日兑换排行</span>
                </section>
                <TabChange
                  code={keyHolidayNum}
                  onChange={(val: string) => {
                    changeKeyHolidayTab(val);
                  }}
                />
              </section>
              <section className="time-change-01">
                <HolidayChange
                  code={activeDay}
                  onChange={(val: number) => {
                    changeKeyHoliday(val);
                  }}
                />
              </section>
              {!isEmpty(keyHolidayLeft) ? (
                <section
                  className="welfare-rank-content"
                  style={{
                    backgroundImage: isMock
                      ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
                      : "",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                  }}
                >
                  <KeyWelfareRank
                    onChange={(val: string) => {
                      changeKeyHolidayMid(val);
                    }}
                  />
                  <section className="welfare-rank-mid">
                    {keyHolidayMid?.map((item: any, i: any) => {
                      return (
                        <section
                          className="welfare-rank-mid-con"
                          key={`${i.toString()}`}
                        >
                          <p>
                            <span>{item.name}</span>
                            <span
                              style={{
                                fontFamily: "Roboto",
                              }}
                            >
                              {round(item.percent * 100, 1)}%
                            </span>
                          </p>
                          <DProgress
                            variant="determinate"
                            value={item.percent * 100}
                          />
                        </section>
                      );
                    })}
                  </section>
                  <section className="welfare-rank-right">
                    <section className="welfare-rank-right-title">
                      <span className="sub-title">品牌</span>
                    </section>
                    {getkeyHolidayRightThree?.map((item: any, i: any) => {
                      return (
                        <section
                          key={`${i.toString()}`}
                          className="welfare-rank-right-list"
                        >
                          <p style={{ color: colorList[i] }}>
                            <RankingLIcon color={colorList[i]} />
                            {i + 1}
                            <RankingRIcon color={colorList[i]} />
                          </p>
                          <span className="content">{item.name}</span>
                        </section>
                      );
                    })}
                  </section>
                </section>
              ) : (
                <Empty />
              )}
            </section>
            <section className="welfare-echange-city">
              <HolidayEchangeCity />
            </section>
          </section>
        )}
      </section>
    </section>
  );
};

export default observer(Hobby);
